import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { RadioGroup, FormControlLabel, Radio, FormControl, Button, Checkbox, FormGroup, CircularProgress, Snackbar } from '@material-ui/core';
import CustomAlert from './CustomAlert';
import { useForm } from 'react-hook-form';
import { registerUser, userMetaData } from './Models/AccountModel';
import server from '../Backend/axios';
import { mapValues } from 'lodash';
import CheckUserProvider from '../AllHooks/CheckUserProvider';
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
import "../../node_modules/@syncfusion/ej2-popups/styles/material.css";
import "../../node_modules/@syncfusion/ej2-react-calendars/styles/material.css";
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { getHoursPerWeekData, getPreferredContractData } from './Models/CommonFunc';
import { Helmet } from 'react-helmet';
import { checkValidation, formParams } from '../Backend/firebase/user';
import db, { auth } from '../Backend/firebase/firebase';

function UpdateUserSkills() {
    const { userData } = CheckUserProvider();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { register, errors, handleSubmit, setValue } = useForm();
    const [maxTravelDistance, setMaxTravelDistance] = useState(null);
    const [userSkills, setUserSkills] = useState(null);
    const [defaultCareerLevel, setDefaultCareerLevel] = useState('');
    const [defaultMaxTravelDistance, setDefaultMaxTravelDistance] = useState('');
    const [defaultAvailableFrom, setDefaultAvailableFrom] = useState('');
    const [employmentTypeValues, setEmploymentTypeValues] = useState({
        'capsule': false,
        'syrup': false,
        'internship': false,
        'temporaryContract': false,
        'freelance': false,
        'traineeship': false,
        'remote': false,
        'sideProduct': false,
    });
    const [hoursPerWeekUpdated, setHoursPerWeekUpdated] = useState({
        'EightHours': false,
        'SixteenHours': false,
        'TwentyFourHours': false,
        'ThirtyTwoHours': false,
        'ThirtySixHours': false,
        'FourtyHours': false,
    });
    const [defaultAvailableFromDate, setDefaultAvailableFromDate] = useState(new Date());
    const [isTravelDistanceKmEnable, setIsTravelDistanceKmEnable] = useState(true);

    useEffect(async () => {
        if (userData) {
            setTimeout(() => {
                mapValues(userData, (value, key) => setValue(key, value));
                mapValues(userData, (value, key) => setValue(key, value));
                setDefaultCareerLevel(userData?.currentCareerLevel);
                mapEmploymentType(userData?.preferredContract);
                mapHoursWeek(userData?.hourPerWeek);
                setDefaultMaxTravelDistance(userData.maxTravelDistanceFromHome);
                if (userData.maxTravelDistanceFromHome === 'I want a maximum single travel distance of: ') {
                    setValue('maxTravelDistanceFromHomeKm', userData.maxTravelDistanceFromHomeKm);
                }
                setDefaultAvailableFrom(userData?.availableFrom);
                if (userData?.availableFrom === 'Available From') {
                    setValue('availableFromDate', userData.availableFromDate);
                }
            });
            setUserSkills(userData);
        }
    }, [userData]);


    // useEffect(async () => {
    //     if (userData) {
    //         await server.get(`/Account/GetUserDetailsForUpdateByUidAsync/${userData.uid}`)
    //             .then((resp) => {
    //                 if (resp.status === 200 && resp.data.message === 'success') {
    //                     setTimeout(() => {
    //                         mapValues(resp.data.data.user, (value, key) => setValue(key, value));
    //                         mapValues(resp.data.data.userMetaData, (value, key) => setValue(key, value));
    //                         setDefaultCareerLevel(resp.data.data.user.currentCareerLevel);
    //                         mapEmploymentType(resp.data.data.userMetaData.preferredContract);
    //                         mapHoursWeek(resp.data.data.userMetaData.hourPerWeek);
    //                         setDefaultMaxTravelDistance(resp.data.data.userMetaData.maxTravelDistanceFromHome);
    //                         if (resp.data.data.userMetaData.maxTravelDistanceFromHome === 'I want a maximum single travel distance of: ') {
    //                             setValue('maxTravelDistanceFromHomeKm', resp.data.data.userMetaData.maxTravelDistanceFromHomeKm);
    //                         }
    //                         setDefaultAvailableFrom(resp.data.data.userMetaData.availableFrom);
    //                         if (resp.data.data.userMetaData.availableFrom === 'Available From') {
    //                             setValue('availableFromDate', resp.data.data.userMetaData.availableFromDate);
    //                         }
    //                     });
    //                     setUserSkills(resp.data.data);
    //                 }
    //             }).catch(err => console.log(err.message));
    //     }
    // }, [userData]);

    const handleAvailableFromDateChange = (e) => {
        setDefaultAvailableFromDate(e.target.value);
    }

    const handleCareerLevelChange = (event) => {
        setDefaultCareerLevel(event.target.value);
    };

    const handleDefaultMaxTravelDistanceChange = (event) => {
        setDefaultMaxTravelDistance(event.target.value);
    };

    const handleDefaultAvailableFromChange = (event) => {
        setDefaultAvailableFrom(event.target.value);
    };

    const handleEmploymentTypeChange = (event) => {
        setEmploymentTypeValues({ ...employmentTypeValues, [event.target.name]: event.target.checked });
    };

    const handlemaxTravelDistanceFromHomeChange = (e) => {
        setMaxTravelDistance(e.target.value);
    }

    useEffect(() => {
        if (maxTravelDistance === 'I am willing to move (temporary) for a new product / assignment') {
            setIsTravelDistanceKmEnable(true);
            setValue('maxTravelDistanceFromHomeKm', '');
        } else if (maxTravelDistance === 'I want a maximum single travel distance of: ') {
            setIsTravelDistanceKmEnable(false);
        }
    }, [maxTravelDistance]);

    const handleHoursPerWeekChange = (event) => {
        setHoursPerWeekUpdated({ ...hoursPerWeekUpdated, [event.target.name]: event.target.checked });
    };

    const mapHoursWeek = (hoursPerWeek) => {
        if (hoursPerWeek) {
            if (hoursPerWeek.split(',').length > 2) {
                for (let index = 0; index < hoursPerWeek.split(',').length; index++) {
                    if (hoursPerWeek.split(',')[index] === "8 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'EightHours': true }));
                    } else if (hoursPerWeek.split(',')[index] === "16 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'SixteenHours': true }));
                    } else if (hoursPerWeek.split(',')[index] === "24 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'TwentyFourHours': true }));
                    } else if (hoursPerWeek.split(',')[index] === "32 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'ThirtyTwoHours': true }));
                    } else if (hoursPerWeek.split(',')[index] === "36 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'ThirtySixHours': true }));
                    } else if (hoursPerWeek.split(',')[index] === "40 hrs") {
                        setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'FourtyHours': true }));
                    }
                }
            } else {
                if (hoursPerWeek.split(',')[0] === "8 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'EightHours': true }));
                } else if (hoursPerWeek.split(',')[0] === "16 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'SixteenHours': true }));
                } else if (hoursPerWeek.split(',')[0] === "24 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'TwentyFourHours': true }));
                } else if (hoursPerWeek.split(',')[0] === "32 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'ThirtyTwoHours': true }));
                } else if (hoursPerWeek.split(',')[0] === "36 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'ThirtySixHours': true }));
                } else if (hoursPerWeek.split(',')[0] === "40 hrs") {
                    setHoursPerWeekUpdated((prevState) => ({ ...prevState, 'FourtyHours': true }));
                }
            }
        }
    }

    const mapEmploymentType = (Compostions) => {
        if (Compostions) {
            if (Compostions.split(',').length > 2) {
                for (let index = 0; index < Compostions.split(',').length; index++) {
                    if (Compostions.split(',')[index] === "Capsule") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'capsule': true }));
                    } else if (Compostions.split(',')[index] === "Freelance") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'freelance': true }));
                    } else if (Compostions.split(',')[index] === "SideProduct") {
                    } else if (Compostions.split(',')[index] === "Temporary Contract") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'temporaryContract': true }));
                    } else if (Compostions.split(',')[index] === "Internship") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'internship': true }));
                    } else if (Compostions.split(',')[index] === "Syrup") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'syrup': true }));
                    } else if (Compostions.split(',')[index] === "Traineeship") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'traineeship': true }));
                    } else if (Compostions.split(',')[index] === "Remote") {
                        setEmploymentTypeValues((prevState) => ({ ...prevState, 'remote': true }));
                    }
                }
            }
            else {
                if (Compostions.split(',')[0] === "Capsule") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'capsule': true }));
                } else if (Compostions.split(',')[0] === "Freelance") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'freelance': true }));
                } else if (Compostions.split(',')[0] === "SideProduct") {
                } else if (Compostions.split(',')[0] === "Temporary Contract") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'temporaryContract': true }));
                } else if (Compostions.split(',')[0] === "Internship") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'internship': true }));
                } else if (Compostions.split(',')[0] === "Syrup") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'syrup': true }));
                } else if (Compostions.split(',')[0] === "Traineeship") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'traineeship': true }));
                } else if (Compostions.split(',')[0] === "Remote") {
                    setEmploymentTypeValues((prevState) => ({ ...prevState, 'remote': true }));
                }
            }
        }
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            // var isAvailableFromDate = defaultAvailableFrom === 'Available From' ? defaultAvailableFromDate ? true : false : true;
            // if (isAvailableFromDate) {

                try {
                    var user = auth.currentUser;
                    if (user) {
                        try {
                            const docRef = db.doc(`/Users/${user.uid}`);
                            await docRef.update({
                                currentCareerLevel: formParams(data?.currentCareerLevel),
                                functionOrUniqueSKills: formParams(data?.functionOrUniqueSKills),
                                productLevel: formParams(data?.productLevel),
                                personalBio: formParams(data?.personalBio),
                                availableFrom: formParams(data?.availableFrom),
                                availableFromDate: formParams(data?.availableFromDate),
                                hourPerWeek: checkValidation(data?.hourPerWeek) ? getHoursPerWeekData(data?.hourPerWeek) : null,
                                maxTravelDistanceFromHome: formParams(data?.maxTravelDistanceFromHome),
                                maxTravelDistanceFromHomeKm: formParams(data?.maxTravelDistanceFromHomeKm)
                            });
                            
                            setNotificationMessage('User skills detail has updated successfully.');
                            setOpenNotify(true);
                            setAlertType('success');
                            setIsLoading(false);
                            window.location.reload(true);
                        } catch(error) {
                            console.log("Error Occur in Update Profile : ", error)
                            setNotificationMessage('Updation Failed!');
                            setOpenNotify(true);
                            setAlertType('error');
                            setIsLoading(false);
                        }
                    }
                } catch (err) {
                    if (err.code === 'auth/requires-recent-login') {
                        setNotificationMessage('To change the email, please logout your account and login again!');
                        setOpenNotify(true);
                        setAlertType('error');
                        setIsLoading(false);
                    } else {
                        //console.log(err);
                        setNotificationMessage('Something goes wrong!');
                        setOpenNotify(true);
                        setAlertType('error');
                        setIsLoading(false);
                    }
                }
                // registerUser.uid = userData.uid;
                // registerUser.currentCareerLevel = data.currentCareerLevel;
                // registerUser.functionOrUniqueSKills = data.functionOrUniqueSKills;
                // registerUser.productLevel = data.productLevel;
                // registerUser.personalBio = data.personalBio;

                // userMetaData.uid = userData.uid;
                // userMetaData.availableFrom = defaultAvailableFrom;
                // if (defaultAvailableFrom === 'Available From')
                //     userMetaData.availableFromDate = defaultAvailableFromDate;
                // else
                //     userMetaData.availableFromDate = null;
                // userMetaData.hourPerWeek = getHoursPerWeekData(hoursPerWeekUpdated);
                // userMetaData.maxTravelDistanceFromHome = data.maxTravelDistanceFromHome;
                // if (data.maxTravelDistanceFromHome === 'I want a maximum single travel distance of: ')
                //     userMetaData.maxTravelDistanceFromHomeKm = data.maxTravelDistanceFromHomeKm;
                // userMetaData.preferredContract = getPreferredContractData(employmentTypeValues);
                // userMetaData.email = userData.email;
                // await server.put('/Account/UpdateUserSkillsAsync', {
                //     user: registerUser,
                //     userMetaData: userMetaData
                // }).then((resp) => {
                //     if (resp.status === 200 && resp.data.message === 'success') {
                //         setNotificationMessage('User skills detail has updated successfully.');
                //         setOpenNotify(true);
                //         setAlertType('success');
                //         setIsLoading(false);
                //         window.location.reload(true);
                //     } else {
                //         if (resp.data.data) {
                //             setNotificationMessage(resp.data.data);
                //             setOpenNotify(true);
                //             setAlertType('error');
                //             setIsLoading(false);
                //         } else {
                //             setNotificationMessage('Updation Failed!');
                //             setOpenNotify(true);
                //             setAlertType('error');
                //             setIsLoading(false);
                //         }
                //     }
                // }).catch((err) => {
                //     setNotificationMessage(err.message);
                //     setOpenNotify(true);
                //     setAlertType('error');
                //     setIsLoading(false);
                // });
            // } else {
            //     setNotificationMessage("If you select available from, please provide date also!");
            //     setOpenNotify(true);
            //     setAlertType('error');
            //     setIsLoading(false);
            // }
        } catch (error) {
            setNotificationMessage(error.message);
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
        }
    };

    return (
        <>
            {userSkills ?
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Helmet>
                        <meta name="description" content="Update user skills..." />
                        <title>Update User Skills | Kaipsool Pharmatech</title>
                    </Helmet>
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="login__textboxLabel"><strong>Desired specific fucntion(s) + your unique skills</strong> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                        <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.functionOrUniqueSKills })}
                                            name="functionOrUniqueSKills" placeholder="Unique Skills" autoComplete="none"
                                            ref={register({ required: 'Please enter your skills!' })} />
                                        <small className="form-text text-danger">{errors.functionOrUniqueSKills && errors.functionOrUniqueSKills.message}</small>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <div className="alert alert-warning" role="alert">
                                        <p>Name your desired function(s) as specifically as possible, also mention your best skills.</p>
                                        <p>Examples. Back-end developer PHP, MySQL, CSS, HTML, System engineer / Network engineer, Windows. VMWare, SQL Server</p>
                                        <p>This title is public so don't enter any private details like name, email, phone</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Your personal bio (non mandatory)</strong></label>
                                <textarea type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.personalBio })}
                                    name="personalBio" placeholder="Personal bio" autoComplete="none"
                                    ref={register}></textarea>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row mt-2">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Product Level</strong> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.productLevel })} aria-label="Default select example"
                                    name="productLevel" ref={register({
                                        required: 'Please select any product level!',
                                        validate: {
                                            defaultValue: value => value !== "Select Level" || 'Please select name title!'
                                        }
                                    })} defaultValue="Select Level">
                                    <option value="Select Level">Select Level</option>
                                    <option value="University">University</option>
                                </select>
                                <small className="form-text text-danger">{errors.productLevel && errors.productLevel.message}</small>
                            </div>
                        </div>
                    </div> */}
                    <div className="row mt-2">
                        {/* <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Your current career level</strong> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label><br></br>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="careerLevel" name="careerLevel"
                                        value={defaultCareerLevel} onChange={handleCareerLevelChange}>
                                        <FormControlLabel value="Junior" control={<Radio className="skilsForm__radioBtn" />}
                                            label="Junior (None or only a few years of experience, needs to learn a lot, needs coaching)"
                                            name="currentCareerLevel"
                                            inputRef={register} />
                                        <FormControlLabel value="Medior" control={<Radio className="skilsForm__radioBtn" />}
                                            label="Medior (Quite a few years of experience, can work on his own, works well together with colleagues, has sufficient knowledge)"
                                            name="currentCareerLevel"
                                            inputRef={register} />
                                        <FormControlLabel value="Senior" control={<Radio className="skilsForm__radioBtn" />}
                                            label="Senior (Years of experience, coaches othe colleagues, has vision, puts out pillars, lots of knowledge)"
                                            name="currentCareerLevel"
                                            inputRef={register} />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div> */}
                        {/* <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Preferred contract (non mandatory)</strong></label><br></br>
                                <FormControl component="fieldset">
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.capsule} name="capsule" onChange={handleEmploymentTypeChange} />}
                                            label="Capsule"
                                            name="preferredContract.capsule"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.freelance} name="freelance" onChange={handleEmploymentTypeChange} />}
                                            label="Freelance"
                                            name="preferredContract.freelance"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.remote} name="remote" onChange={handleEmploymentTypeChange} />}
                                            label="Remote"
                                            name="preferredContract.remote"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.temporaryContract} name="temporaryContract" onChange={handleEmploymentTypeChange} />}
                                            label="Temporary Contract"
                                            name="preferredContract.temporaryContract"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.internship} name="internship" onChange={handleEmploymentTypeChange} />}
                                            label="Internship"
                                            name="preferredContract.internship"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.syrup} name="syrup" onChange={handleEmploymentTypeChange} />}
                                            label="Syrup"
                                            name="preferredContract.syrup"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={employmentTypeValues.traineeship} name="traineeship" onChange={handleEmploymentTypeChange} />}
                                            label="Traineeship"
                                            name="preferredContract.traineeship"
                                            inputRef={register}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div> */}
                        {/* <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Number of hours per week (non mandatory)</strong></label><br></br>
                                <FormControl component="fieldset">
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.EightHours} name="EightHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="8 hrs"
                                            name="hourPerWeek.EightHours"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.SixteenHours} name="SixteenHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="16 hrs"
                                            name="hourPerWeek.SixteenHours"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.TwentyFourHours} name="TwentyFourHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="24 hrs"
                                            name="hourPerWeek.TwentyFourHours"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.ThirtyTwoHours} name="ThirtyTwoHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="32 hrs"
                                            name="hourPerWeek.ThirtyTwoHours"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.ThirtySixHours} name="ThirtySixHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="36 hrs"
                                            name="hourPerWeek.ThirtySixHours"
                                            inputRef={register}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox className="registerEmp__acceptTerms"
                                                checked={hoursPerWeekUpdated.FourtyHours} name="FourtyHours"
                                                onChange={handleHoursPerWeekChange} />}
                                            label="40 hrs"
                                            name="hourPerWeek.FourtyHours"
                                            inputRef={register}
                                        />
                                    </FormGroup>
                                </FormControl>
                            </div>
                        </div> */}

                        {/* <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Max. travel distance from home (non mandatory)</strong></label><br></br>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="careerLevel" name="maxTravelDistance"
                                        value={defaultMaxTravelDistance} onChange={handleDefaultMaxTravelDistanceChange}>
                                        <FormControlLabel value="I want a maximum single travel distance of: "
                                            control={<Radio className="skilsForm__radioBtn" />}
                                            label="I want a maximum single travel distance of: "
                                            name="maxTravelDistanceFromHome"
                                            inputRef={register} onChange={handlemaxTravelDistanceFromHomeChange} />
                                        <input type="text" className={classNames("form-control registerEmp__textbox skilsForm__maxTravelDistanceKmInput", { "is-invalid": errors.maxTravelDistanceFromHomeKm })}
                                            name="maxTravelDistanceFromHomeKm" placeholder="Distance" autoComplete="none"
                                            ref={register({
                                                required: maxTravelDistance ?
                                                    maxTravelDistance === "I want a maximum single travel distance of: " ? 'Please enter distance in Km!' : false : null
                                            })}
                                            disabled={isTravelDistanceKmEnable} />
                                        <small className="form-text text-danger">{errors.maxTravelDistanceFromHomeKm && errors.maxTravelDistanceFromHomeKm.message}</small>
                                        <FormControlLabel value="I am willing to move (temporary) for a new product / assignment" control={<Radio className="skilsForm__radioBtn" />} className="skilsForm__temporaryMove"
                                            label="I am willing to move (temporary) for a new product / assignment"
                                            name="maxTravelDistanceFromHome"
                                            inputRef={register} onChange={handlemaxTravelDistanceFromHomeChange} />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div> */}
                        {/* <div className="col-md-4 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel"><strong>Available From (non mandatory)</strong></label><br></br>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="careerLevel" name="available"
                                        value={defaultAvailableFrom} onChange={handleDefaultAvailableFromChange}>
                                        <FormControlLabel value="Available immediately" control={<Radio className="skilsForm__radioBtn" />}
                                            label="Available immediately"
                                            name="availableFrom"
                                            inputRef={register} />
                                        <FormControlLabel value="Available From" control={<Radio className="skilsForm__radioBtn" />}
                                            label="Available From:"
                                            name="availableFrom"
                                            inputRef={register} />
                                        <DatePickerComponent id="defaultAvailableFromDate" value={defaultAvailableFromDate} cssclassName="e-outline"
                                            onChange={(e) => handleAvailableFromDateChange(e)} ref={register} name="availableFromDate" />
                                        <FormControlLabel value="Open for a better offer" control={<Radio className="skilsForm__radioBtn" />} className="skilsForm__temporaryMove"
                                            label="Open for a better offer"
                                            name="availableFrom"
                                            inputRef={register} />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div> */}
                    </div>

                    <div className="row pb-3">
                        <div className="col-md-12 text-center mt-2">
                            <Button type="submit" className="multiStepRegister__btnLogin" variant="contained">
                                {isLoading ? <CircularProgress size={18} /> : 'Submit'}
                            </Button>
                        </div>
                    </div>
                </form>
                : <div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>}
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateUserSkills
